import React from 'react';
import { motion } from 'framer-motion';
import { Video } from 'lucide-react';

const TOURS = [
  {
    id: 'front',
    title: 'Front Area — Main Lounge & Café',
    description: 'Comfortable seating, warm lighting, and our café counter — the heart of the Vibe.',
    video: 'https://customer-assets.emergentagent.com/job_pottstown-vibe-hub/artifacts/7ix51q2f_copy_5B1C169F-495E-4BF6-B2EC-9081F286AC7A.mov',
    poster: 'https://customer-assets.emergentagent.com/job_pottstown-vibe-hub/artifacts/2fyaqe3g_vibe%20picture%20.JPG'
  },
  {
    id: 'back',
    title: 'Back Area — Workspace & Kitchen',
    description: 'The commercial kitchen and collaborative workspaces.',
    video: 'https://customer-assets.emergentagent.com/job_pottstown-vibe-hub/artifacts/meeh3zhd_copy_51B6D70B-2E29-478B-A12A-B0E6B179EDA5.mov',
    poster: 'https://customer-assets.emergentagent.com/job_pottstown-vibe-hub/artifacts/2fyaqe3g_vibe%20picture%20.JPG'
  }
];

const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
};

const VirtualTour = () => {
  return (
    <section id="virtual-tour" data-testid="virtual-tour-section" className="bg-[#f4ede3] px-6 py-24 sm:px-12 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-body text-[11px] font-medium uppercase tracking-[0.45em] text-[#c96f1e]">
            Step Inside
          </p>
          <h2 className="font-display mt-4 text-[clamp(2.6rem,6vw,4.5rem)] font-semibold leading-[1.02] tracking-tight text-[#14100d]">
            Take the <span className="italic text-[#c96f1e]">virtual tour</span>
          </h2>
          <p className="font-body mt-5 max-w-2xl text-base leading-relaxed text-[#4d453c] sm:text-lg">
            Explore the space from wherever you are — then come feel the vibe in person.
          </p>
        </motion.div>

        <div className="mt-14 space-y-10">
          {TOURS.map((tour, index) => (
            <motion.div
              key={tour.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: index * 0.1 }}
              data-testid={`tour-${tour.id}`}
              className="overflow-hidden rounded-2xl bg-[#14100d] shadow-2xl"
            >
              <div className="flex items-center gap-3 px-6 py-4">
                <Video size={20} className="text-[#f2a33c]" />
                <h3 className="font-display text-xl font-semibold text-[#f4ede3] sm:text-2xl">{tour.title}</h3>
              </div>
              <div className="bg-black">
                <video controls className="max-h-[600px] w-full" poster={tour.poster} preload="metadata">
                  <source src={tour.video} type="video/quicktime" />
                  <source src={tour.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <p className="font-body px-6 py-4 text-sm text-[#b8ac9c]">{tour.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="font-body text-lg text-[#4d453c]">Ready to experience the Vibe in person?</p>
          <button
            data-testid="tour-visit-button"
            onClick={() => scrollToId('contact')}
            className="btn-pill font-body mt-5"
          >
            Visit Us Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default VirtualTour;
